import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Home from "./Page/Home";
import About from "./Page/About";
import Rooms from "./Page/Rooms";
import SubNav from "./components/SubNav";
import Footer from "./components/Footer";
import DetailRoom from "./components/DetailRoom";
import Promotions from "./Page/Promotions";
import Gallery from "./Page/Gallery";
import "./i18n"; // Import cấu hình i18n
import i18next from "i18next";
import Contact from "./components/Contact";
import BookRoom from "./components/BookRoom";
import FloatingButtons from "./components/FloatingButtons";
import ScrollToTop from "./components/ScrollToTop";
import FooterRouter from "./Page/Footer";

const App = () => {
  useEffect(() => {
    const currentLang = window.localStorage.getItem("i18nextLng") || "VI";
    i18next.changeLanguage(currentLang);
  }, []);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Router>
      <div style={{ margin: "0 auto" }} className="xl:max-w-[1450px] relative">
        <div className="lg:mt-[135px] ssx:mt-[80px] lg:mx-0 ssx:mx-[10px]">
          <div
            className={`top-0 left-0 right-0 fixed z-50 transition-shadow duration-300 ${
              isScrolled ? "shadow__nav" : ""
            }`}
          >
            <SubNav isScrolled={isScrolled} />
          </div>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/rooms/detail-rooms" element={<DetailRoom />} />
            <Route path="/promotions" element={<Promotions />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<BookRoom />} />
          </Routes>
        </div>
      </div>
      <FooterRouter />
      {/* Add FloatingButtons here to make it appear on all pages */}
      <FloatingButtons />
    </Router>
  );
};

export default App;
